import { render } from "./RegisterStepTwo.vue?vue&type=template&id=35929791"
import script from "./RegisterStepTwo.vue?vue&type=script&lang=js"
export * from "./RegisterStepTwo.vue?vue&type=script&lang=js"
script.render = render

export default script